export const ONBOARDING = {
  // Нажатие на кнопку «Get Started»
  onboardingGetStartedTap: 'onboarding_get_started_tap',

  // Открытие экрана «Quick Start»
  onboardingQuickStartShow: 'onboarding_quick_start_show',
}

export default ONBOARDING
